import { Cookies } from "react-cookie-consent";
import { AppConfigData } from "../CommonService";
import axios from "axios";

export const SendAdminUserPasswordEmailForgotPassword = async (ReqData: any) => {
  try {
    const response = await axios({
      method: "POST",
      url: AppConfigData.APIBasePath + "AdminPanel/api/Clients/SendAdminUserPasswordEmailForgotPassword",
      data: ReqData,
      // headers: {
      //   "Content-Type": "application/json",
      //   Authorization: "bearer " + accessToken,
      // },
    });
    return response;
  } catch (error: any) {
    let data: any = null
    if (error.response.status === 401) {
      data = {
        data: {
          success: false,
          StatusCode: "401",
          Message: "Session has been expired.",
        },
      };
      Cookies.remove("SystemSettingDate");
      Cookies.remove("SystemSettingTime");
      localStorage.clear()
      window.location.pathname = '/'
    } else {
      data = {
        data: {
          success: false,
          StatusCode: "02",
          Message: "Something Wrong in API",
        },
      };
    }
    return data;
  }
}